export default "__VITE_PUBLIC_ASSET__68d2ebc7__"